import { MutationTypeCodes, ResourceTypeMutationCodes, } from '@/store/interfaces';
import { ResourceSearchService } from '@/services/resource-search-service';
import { SortOrder } from '@/services/common/enums';
const emptySearchRequest = {
    SearchCriteria: {},
};
const searchService = new ResourceSearchService();
export const actions = {
    async SubmitTextOnlyRequest({ commit }, searchText) {
        const searchRequest = {
            SearchCriteria: {
                text: searchText,
            },
            Sort: SortOrder.TitleAZ,
            Limit: process.env.VUE_APP_PAGE_SIZE,
            Offset: 0,
        };
        commit(MutationTypeCodes.SET_CURRENT_SEARCH_REQUEST, searchRequest);
    },
    async search({ state, commit }, searchRequest) {
        commit(MutationTypeCodes.SET_SEARCH_STATUS, true);
        if (state.currentSearchRequest.Offset > 0 &&
            JSON.stringify(state.currentSearchRequest.SearchCriteria) !== JSON.stringify(searchRequest.SearchCriteria)) {
            searchRequest.Offset = 0;
        }
        commit(MutationTypeCodes.SET_CURRENT_SEARCH_REQUEST, searchRequest);
        const response = await searchService.PostRequest(searchRequest);
        commit(MutationTypeCodes.SET_CURRENT_RESPONSE, response);
        commit(MutationTypeCodes.SET_SEARCH_STATUS, false);
    },
    async resetFilters({ commit }) {
        commit(MutationTypeCodes.RESET_FILTERS);
    },
    async addCategory({ state, commit, dispatch }, identifier) {
        commit(MutationTypeCodes.ADD_CATEGORY, identifier);
        commit(MutationTypeCodes.RESET_OFFSET);
        dispatch('search', state.currentSearchRequest);
    },
    async removeCategory({ state, commit, dispatch }, identifier) {
        commit(MutationTypeCodes.REMOVE_CATEGORY, identifier);
        commit(MutationTypeCodes.RESET_OFFSET);
        dispatch('search', state.currentSearchRequest);
    },
    async setSortOrder({ state, commit, dispatch }, sortOrder) {
        commit(MutationTypeCodes.SET_SORT_OPTION, sortOrder);
        dispatch('search', state.currentSearchRequest);
    },
    // Resource only specific actions
    async setResourceType({ state, commit, dispatch }, resourceType) {
        commit(ResourceTypeMutationCodes.SET_RESOURCE_TYPE, resourceType);
        commit(MutationTypeCodes.RESET_OFFSET);
        dispatch('search', state.currentSearchRequest);
    },
    async removeResourceType({ state, commit, dispatch }) {
        commit(ResourceTypeMutationCodes.REMOVE_RESOURCE_TYPE);
        commit(MutationTypeCodes.RESET_OFFSET);
        dispatch('search', state.currentSearchRequest);
    },
};
